import { Breakpoint, Theme } from "@mui/material/styles";

const getMediaQueryList = (theme: Theme, breakpoint: Breakpoint) => window.matchMedia(theme.breakpoints.up(breakpoint).replace(/^@media( ?)/m, ""));

export const getCurrentBreakpoint = (theme: Theme): Breakpoint =>
    [...theme.breakpoints.keys].reverse().find(breakpoint => getMediaQueryList(theme, breakpoint).matches) ?? theme.breakpoints.keys[0];

export const subscribeToBreakpointChange = (theme: Theme, onChange: () => void) => {
    const mediaQueryLists = theme.breakpoints.keys.map(breakpoint => getMediaQueryList(theme, breakpoint));
    mediaQueryLists.forEach(mediaQueryList => mediaQueryList.addEventListener("change", onChange));

    return () => {
        mediaQueryLists.forEach(mediaQueryList => mediaQueryList.removeEventListener("change", onChange));
    };
};
